import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import cn from 'classnames';
import s from './announcement-ribbon.module.css';
import clsx from 'clsx';

interface AnnouncementItem {
    text: string;
    link?: string;
    iconURL?: string;
}

interface Announcement {
    backgroundColour?: string;
    textColour?: string;
    closeColour?: string;
    items: AnnouncementItem[];
}
interface RibbonProps {
    announcement: Announcement;
    countryCode: string;
    userCountryVercel?: string;
    customName?: string;
}

let name = 'Announcement Ribbon';

const AnnouncementRibbon = ({
    announcement,
    countryCode,
    userCountryVercel,
    customName,
    ...props
}: RibbonProps) => {
    const renderAnnouncementArray = () => {
        return announcement.items.map((item, index) => {
            const { text, link = '', iconURL } = item;
            if (!text) return;

            let href = link;
            if (link && link.indexOf('http') === -1) {
                href =
                    countryCode.toUpperCase() === 'AU'
                        ? link
                        : `/${countryCode.toLowerCase()}${link}`;
            }

            if (link) {
                return (
                    <span key={`announcementItem${index}`} className={s.item}>
                        {iconURL && (
                            <Image
                                src={iconURL}
                                alt={`icon for ${text}`}
                                key={`announcementItemIcon${index}`}
                                width={14}
                                height={10.5}
                                className={s.icon}
                            />
                        )}
                        <Link href={href} prefetch={false} className={s.link}>
                            {text}
                        </Link>
                        <span>{' >'}</span>
                    </span>
                );
            }

            return (
                <span
                    key={`announcementItem${index}`}
                    className={clsx(s.item, s.noLink)}
                >
                    {iconURL && (
                        <Image
                            src={iconURL}
                            alt={`icon for ${text}`}
                            key={`announcementItemIcon${index}`}
                            width={14}
                            height={10.5}
                            className={s.icon}
                        />
                    )}
                    {text}
                </span>
            );
        });
    };

    if (
        !announcement?.items ||
        !Array.isArray(announcement.items) ||
        !announcement.items.length
    ) {
        return null;
    }

    return (
        <div
            role="navigation"
            className={s.root}
            style={{
                backgroundColor: announcement.backgroundColour || '#222222',
                color: announcement.textColour || '#ffffff',
            }}
            data-testid={`ribbon-${name}`}
            {...props}
        >
            <div className={s.column}></div>
            <div className={s.column}>
                <div className={cn(s.content, 'mmds-component-one-detail')}>
                    {renderAnnouncementArray()}
                </div>
            </div>
        </div>
    );
};

export default AnnouncementRibbon;
